import { Fragment, ReactElement, useState } from 'react';

import { Spin } from 'antd';

import { css } from '@emotion/react';
import { ApiResponse } from '@type/web/api';
import { FraudLocalDetailResultType, LocalResultType } from '@type/web/fraud';

import IconLoading from '@components/web/common/icons/IconLoading';

import InfoPopUp from '../../common/InfoPopUp';
import CloseButton from './CloseButton';
import ResultDetailBigData from './ResultDetailBigData';
import ResultDetailCS from './ResultDetailCS';
import ResultDetailGuide from './ResultDetailGuide';
import ResultDetailMonitoring from './ResultDetailMonitoring';

interface LocalResultDetailProps {
  detail: {
    isFetching: boolean;
    reportPath: LocalResultType['report_path'];
    localDetail: ApiResponse<FraudLocalDetailResultType> | undefined;
    closeLocalDropdown: () => void;
  };
}

export default function LocalResultDetail({
  detail: { isFetching, reportPath, localDetail, closeLocalDropdown },
}: LocalResultDetailProps): ReactElement {
  const [infoText, setInfoText] = useState<string>('');
  const [onToggle, setToggle] = useState<boolean>(false);

  const infoTextMap = {
    cs: `피해등록 및 중고나라 고객센터에 \n 접수되어 확인된 통계입니다.`,
    monitoring: `중고나라에서 모니터링을 통해\n제재한 입력정보 연관 거래의\n합계입니다.`,
    bigData: `중고나라 시스템에서 빅데이터 \n 분석을 통한 통계입니다.`,
  };

  const handleToggle = (text?: string) => {
    setInfoText(text || '');
    setToggle(!onToggle);
  };

  return (
    <Fragment>
      {isFetching ? (
        <IconLoading type="CenterLayout" />
      ) : (
        <div css={resultDetailWrap}>
          <ResultDetailCS
            props={{ handleToggle, infoText: infoTextMap.cs, reportPath }}
          />
          <ResultDetailMonitoring
            props={{
              handleToggle,
              infoText: infoTextMap.monitoring,
              reportPath,
            }}
          />
          <ResultDetailBigData
            props={{ handleToggle, infoText: infoTextMap.bigData, localDetail }}
          />
          <ResultDetailGuide />
          <CloseButton closeEvent={closeLocalDropdown} />
          {onToggle && (
            <InfoPopUp>
              <p>{infoText}</p>
              <button
                type="button"
                aria-label="confirm"
                onClick={() => handleToggle()}
              >
                확인
              </button>
            </InfoPopUp>
          )}
        </div>
      )}
    </Fragment>
  );
}

const spin = css`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 160px;
`;

const loading = css`
  width: 100%;
  height: 364px;
  border-bottom: 1px solid #e0e0e0;
`;

const resultDetailWrap = css`
  width: 100%;
  display: grid;
  border-bottom: 1px solid #e0e0e0;
  padding: 20px 8px 0 8px;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 15px;
  white-space: pre-line;
`;
